import { useState, useCallback } from 'react';
import { SortingState } from '@tanstack/react-table';

export function useTableState(initialPageSize = 10) {
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: initialPageSize });
  const [sorting, setSorting]       = useState<SortingState>([]);
  const [globalFilter, setGlobalFilter] = useState('');

  const handleFilterChange = useCallback((value: string) => {
    setGlobalFilter(value);
    setPagination(p => ({ ...p, pageIndex: 0 }));
  }, []);

  const resetPage = useCallback(() => setPagination(p => ({ ...p, pageIndex: 0 })), []);

  return {
    pagination,
    setPagination,
    sorting,
    setSorting,
    globalFilter,
    setGlobalFilter,
    handleFilterChange,
    resetPage,
  };
}
